/* cg-order-r50.js (R50, Oct 17 2026). Fixes from the Oct 17 ordering QA pass. Loaded sitewide from
   snippets/card-description-clamp.liquid, right after cg-time-fix.js.
   1. One source of truth for pickup/delivery and time: the cart attributes. Every restaurant cart update that
      carries Requested Time now also carries Order Timing, Scheduled Date and Scheduled Time, so the cart page
      scheduler (cg-order-scheduler) and cg-fresh-time read the same choice the menu made. Before this a
      scheduled order flipped to ASAP the moment the guest opened /cart. (The inline block in
      card-description-clamp copies the cart's choice into cgm_setup_v1 before cg-menu.js boots.)
   2. Required pick-one groups start empty: bread, side, temp, sauce must be chosen, nothing is pre-picked.
      Edit keeps what was ordered.
   3. "Your 2 sides" groups need that many picks ("No Side" counts as done).
   4. Promise times: pickup about 15 min, delivery about 35 to 45 min, everywhere the guest sees a time.
   5. Cart page "Complete your meal" row lines up with the page.
   6. Display-only spelling fixes for Toast modifier names (TYPO map). Only the text the guest reads changes; the
      value sent to Checkmate stays the exact Toast name so the order still maps. Once the name is fixed in Toast
      and resynced, remove its entry here. */
(function () {
  'use strict';
  if (window.__cgR50) return; window.__cgR50 = true;
  var ETA = 'about 35 to 45 min';
  var TYPO = { 'Grilled Musrooms': 'Grilled Mushrooms' };

  /* ---------- 1. complete the time attributes ---------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function clock(hh, mm) { var ap = hh >= 12 ? 'PM' : 'AM', h = hh % 12 || 12; return h + ':' + pad(mm) + ' ' + ap; }
  function complete(a) {
    if (!a || typeof a !== 'object' || a['Channel'] !== 'restaurant' || !('Requested Time' in a)) return a;
    if (a['Catering Order'] === 'Yes') return a;
    var req = String(a['Requested Time'] || ''), iso = String(a['Pickup Time ISO'] || '');
    var sched = req && req !== 'ASAP';
    if (!a['Order Timing']) a['Order Timing'] = sched ? 'Scheduled' : 'ASAP';
    var m = /^(\d{4}-\d\d-\d\d)T(\d\d):(\d\d)/.exec(iso);
    if (a['Order Timing'] === 'Scheduled' && m) {
      if (!a['Scheduled Date']) a['Scheduled Date'] = m[1];
      if (!a['Scheduled Time']) a['Scheduled Time'] = clock(+m[2], +m[3]);
    } else if (a['Order Timing'] === 'ASAP') { a['Scheduled Date'] = ''; a['Scheduled Time'] = ''; }
    if (!('Catering Order' in a)) a['Catering Order'] = 'No';
    return a;
  }
  var of = window.fetch;
  if (of && !of.__cgR50) {
    var w = function (url, opts) {
      try {
        var u = typeof url === 'string' ? url : (url && url.url) || '';
        if (/\/cart\/update(\.js)?(\?|$)/.test(u) && opts && typeof opts.body === 'string' && opts.body.charAt(0) === '{') {
          var b = JSON.parse(opts.body);
          if (b && b.attributes) { b.attributes = complete(b.attributes); opts = Object.assign({}, opts, { body: JSON.stringify(b) }); }
        }
      } catch (e) {}
      return of.apply(this, [url, opts]);
    };
    Object.keys(of).forEach(function (k) { w[k] = of[k]; }); w.__cgR50 = true; window.fetch = w;
  }

  /* ---------- 2 + 3. dish sheet rules ---------- */
  function need(g) {
    var n = +g.dataset.r50need; if (!n) return;
    var none = Array.prototype.some.call(g.querySelectorAll('input:checked'), function (i) { return /^no side/i.test(i.value); });
    g.dataset.min = none ? 1 : n;
  }
  function prepSheet() {
    var host = document.querySelector('.cgm-sheet .cgc-modal__content'); if (!host) return;
    var first = host.firstElementChild; if (!first || host.__r50 === first) return; host.__r50 = first;
    var sub = host.querySelector('[data-submit]'), editing = sub && /^\s*Update/.test(sub.textContent || '');
    var touched = false;
    host.querySelectorAll('.cgm-group').forEach(function (g) {
      var t = g.querySelector('.cgc-opt__title'), name = t ? t.textContent : '';
      if (g.dataset.required === '1' && g.dataset.multi !== '1' && !editing) {
        g.querySelectorAll('input:checked').forEach(function (i) { i.checked = false; touched = true; });
      }
      var m = /\b(\d+)\s+sides?\b/i.exec(name), n = m ? +m[1] : 0;
      if (n > 1 && g.dataset.multi === '1') {
        g.dataset.r50need = n; need(g);
        var r = g.querySelector('.cgm-rule'); if (r) r.textContent = (g.dataset.required === '1' ? 'Required' : 'Optional') + ' · pick ' + n;
        var e = g.querySelector('.cgm-group__err'); if (e) e.textContent = 'Pick ' + n + ' to continue';
      }
    });
    if (touched) host.dispatchEvent(new Event('change', { bubbles: true }));
  }
  document.addEventListener('change', function (e) { var g = e.target && e.target.closest && e.target.closest('.cgm-group[data-r50need]'); if (g) need(g); }, true);

  /* ---------- 4 + 6. text the guest reads ---------- */
  var DEL_ASAP = /Delivery ASAP · ready by \d{1,2}:\d\d [AP]M/;
  var TYPO_RE = new RegExp(Object.keys(TYPO).join('|'), 'g');
  function fixText(node) {
    if (!node) return;
    var tw = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, null), t;
    while ((t = tw.nextNode())) {
      var v = t.nodeValue, nv = v;
      if (DEL_ASAP.test(nv)) nv = nv.replace(DEL_ASAP, 'Delivery ASAP · arrives in ' + ETA);
      if (TYPO_RE.test(nv)) { TYPO_RE.lastIndex = 0; nv = nv.replace(TYPO_RE, function (k) { return TYPO[k]; }); }
      TYPO_RE.lastIndex = 0;
      if (nv !== v) t.nodeValue = nv;
    }
  }
  function relabel() {
    document.querySelectorAll('[data-cgm-setup-summary], .cgm-bar [data-when], .cgm-panel, .lux-bar__when, .cgm-sheet.is-open, cart-items, cart-drawer, .cart-drawer').forEach(fixText);
    var su = document.querySelector('.cgm-setup.is-open');
    if (su) {
      var del = !!su.querySelector('[data-mode="delivery"][aria-pressed="true"]');
      var r = su.querySelector('input[name="cgm-when"][value="asap"]'), pr = r && r.parentNode.querySelector('.cgc-choice__price');
      if (pr) {
        if (!pr.dataset.r50) pr.dataset.r50 = pr.textContent;
        var want = del && !r.disabled ? 'arrives in ' + ETA : pr.dataset.r50;
        if (pr.textContent !== want) pr.textContent = want;
      }
      var note = su.querySelector('[data-modenote]');
      if (note && del && !/35 to 45/.test(note.textContent)) note.textContent = 'Local delivery around Whittier, usually 35 to 45 min. Enter your zip to check.';
    }
    document.querySelectorAll('.cgm-facts span').forEach(function (s) { if (/Pickup in about 20 min/.test(s.textContent)) s.textContent = 'Pickup about 15 min · Delivery 35 to 45 min'; });
  }

  var tm = null;
  function tick() { clearTimeout(tm); tm = setTimeout(function () { prepSheet(); relabel(); }, 30); }
  function boot() {
    new MutationObserver(tick).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-pressed', 'class'] });
    tick();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  /* ---------- 5. cart cross-sell row alignment ---------- */
  var css = document.createElement('style');
  css.textContent = '.cart__footer-wrapper>.cg-ups{max-width:var(--page-width);margin-left:auto;margin-right:auto;padding-left:1.5rem;padding-right:1.5rem;box-sizing:border-box}@media screen and (min-width:750px){.cart__footer-wrapper>.cg-ups{padding-left:5rem;padding-right:5rem}}';
  (document.head || document.documentElement).appendChild(css);
})();
